import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../../../../../constants/common'
import { FieldStackedLabel } from '../../../../../../../Field'
import { FormFieldSelectNG } from '../../../../../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../../../Formik'
import { UserInfoStatusMultiSelect } from '../../../../../../../User'
import { NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_USER_INFO_STATUS } from '../../../RecipientsField.constants'

function RecipientInfoStatus({ disabled }) {
  const { t } = useTranslation()

  return (
    <FormikField
      multi
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={UserInfoStatusMultiSelect}
      controlProps={{
        contentProps: {
          inputProps: {
            placeholder: t('Newsboard.RecipientsUserInfoStatusPlaceholderKey'),
          },
        },
      }}
      disabled={disabled}
      emptyValue={EMPTY_LIST}
      fieldComponentProps={{
        disabled,
        label: t('Newsboard.RecipientsUserInfoStatusLabelKey'),
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_USER_INFO_STATUS}
    />
  )
}

export default RecipientInfoStatus
